import { buildNeighborhoodOfficeSeo } from 'ux/Public/OfficeSeo/data/officeSeoNeighborhoodBuild';

export const nycMidtownOfficeSeo = buildNeighborhoodOfficeSeo({
  cityPathSegment: 'new-york',
  neighborhoodSlug: 'midtown',
  neighborhoodDisplayName: 'Midtown',
  metroDisplayName: 'New York',
  totalCodiClientsInNeighborhood: 4,
  nycLocalPreset: 'manhattanStandard',
  whereFromStreetsToLandmark:
    'from the buildings along W 38th St, W 40th St, and th Ave to the clusters near Grand Central',
  whereTeamStreets: 'W 38th St, W 40th St, th Ave, 5th Ave',
  clientDescriptor: 'a small team tech startup near W 40th St',
  counts: {
    managedCleaningOffices: 4,
    managedPantryOffices: 4,
    managedInternetOffices: 4,
    managedFurnitureOffices: 4,
    managedOfficeAssistantOffices: 4,
    managedDeepCleaningOffices: 3,
    managedCarpetCleaningOffices: 2,
    managedWindowCleaningOffices: 2,
    managedGlassCleaningOffices: 3,
    managedWasteRecyclingOffices: 2,
    managedPantryInventoryOffices: 4,
    managedCoffeeServiceOffices: 3,
    managedWaterServiceOffices: 3,
    managedTeamLunchOffices: 2,
    managedBreakfastCateringOffices: 2,
    managedIndividualMealsOffices: 1,
    managedAdHocCateringOffices: 2,
    managedHappyHourOffices: 2,
    managedConferenceRoomAvOffices: 2,
    managedNetworkInstallationOffices: 3,
    managedNetworkManagementOffices: 2,
    managedCableManagementOffices: 2,
    managedRoomBookingOffices: 2,
    managedPrintingSetupOffices: 2,
    managedInteriorDesignOffices: 2,
    managedOfficeMuralsOffices: 1,
    managedOfficePaintingOffices: 1,
    managedGlassFrostingOffices: 2,
    managedOfficeSignageOffices: 1,
    managedCareRoomOffices: 1,
    managedFurnitureAssemblyOffices: 2,
    managedLayoutChangeOffices: 2,
    managedOfficePlantsOffices: 2,
    managedKeylessAccessOffices: 3,
    managedAlarmSystemsOffices: 2,
    managedSecurityCamerasOffices: 2,
    managedKeypadOffices: 2,
    managedLockboxOffices: 1,
    managedVisitorManagementOffices: 2,
    managedBusinessInsuranceOffices: 2,
    managedElectricalServicesOffices: 9,
    managedHvacOffices: 7,
    managedPlumbingOffices: 6,
    managedPestControlOffices: 6,
    managedOfficeMovingOffices: 8,
    managedMountingInstallationOffices: 11
  },
  quotes: {
    cleaning: 'The Codi team has been very responsive whenever a maintenance issue comes up.',
    pantryRestocking: "Manhattan delivery windows are brutal. Codi figures it out so we don't have to.",
    internet: "Codi coordinated everything with the building ops team so we didn't have to.",
    officeAssistant: "Codi's on-site person handles packages, visitors, and vendor access \u2014 all of it.",
    officeFurniture: "We moved in and the space was already set up. That's what Codi does.",
    deepCleaning: 'Midtown offices see a lot of foot traffic. Quarterly deep cleans are essential. Codi runs it.',
    carpetCleaning: 'High-traffic Midtown office, carpet shows wear fast. Codi keeps it on a cleaning schedule.',
    windowCleaning: 'Midtown skyline views are a selling point. Codi keeps the windows clean year-round.',
    glassConferenceRoom: 'Client meetings happen daily in Midtown. Codi keeps the glass conference rooms immaculate.',
    wasteRecycling: 'NYC waste compliance is non-negotiable. Codi manages our compliant pickup schedule.',
    pantryInventory: 'Pantry inventory management in a Midtown office is a real job. Codi automated the whole thing.',
    coffeeService:
      'Midtown office standard \u2014 quality coffee, always stocked, machine always working. Codi handles it.',
    waterService: 'Filtered water in our 42nd St office. Codi set up the system and maintains it on a schedule.',
    teamLunch:
      'We do weekly team lunch in Midtown. Codi coordinates with local caterers and manages delivery logistics.',
    breakfastCatering: 'Monday all-hands needs a proper breakfast. Codi handles the order and delivery consistently.',
    individualMeals: 'Individual lunch program for the Midtown team. Codi manages the vendor and keeps it on schedule.',
    adHocCatering:
      'Midtown means constant client visits. Codi handles catering for every meeting without us asking twice.',
    happyHour: 'Thursday happy hour is a Midtown tradition for our team. Codi handles drinks and setup every week.',
    conferenceRoomAv:
      'Midtown board room needed broadcast-quality A/V. Codi sourced the right vendor and managed the install.',
    networkInstallation:
      'New Midtown floor, needed a full network buildout. Codi handled ISP coordination and managed switch install.',
    networkManagement:
      'Codi monitors our Midtown network around the clock. We get a ticket resolved before we notice the problem.',
    cableManagement:
      'Midtown high-rise has strict IT access rules. Codi knew the building policies and managed the cable runs cleanly.',
    roomBooking:
      'Seven conference rooms across two floors. Codi deployed the booking system and handles all hardware maintenance.',
    printingSetup:
      'Enterprise printer rollout across the Midtown floor. Codi handled freight coordination and every driver install.',
    interiorDesign:
      'Midtown relocation needed a full fit-out. Codi handled space planning, vendor sourcing, and project management.',
    officeMurals:
      'Brand wall in the Midtown lobby. Codi sourced the artist, got building approval, and managed the installation.',
    officePainting:
      'Pre-move-in painting across three floors. Codi coordinated after-hours access and COI compliance for the painters.',
    glassFrosting:
      'Conference room privacy film across the Midtown floor. Codi measured and installed in a single day.',
    officeSignage:
      'Midtown office, client-facing environment. Codi installed lobby signage, floor directories, and wayfinding.',
    careRoom:
      'HR flagged the need for a proper care room. Codi set it up with the right furniture and privacy features quickly.',
    furnitureAssembly:
      'Full-floor furniture delivery for 50 people. Codi coordinated freight elevator access and assembly crews.',
    layoutChange:
      'Executive floor restack. Codi managed furniture moves, cable rerouting, and building coordination over one weekend.',
    officePlants:
      'Midtown high-rise with limited natural light. Codi curated a low-light plant program that actually thrives.',
    keylessAccess:
      'Midtown high-rise required keyless access registration with building security. Codi managed the full process from vendor selection to credential setup.',
    alarmSystems:
      'Monitored alarm in our Midtown office. Codi coordinated building approval, insurance, and ongoing vendor management.',
    securityCameras:
      'Client-facing Midtown office needed security camera coverage. Codi installed and manages remote access.',
    keypads: 'Three entry doors in our Midtown space. Codi installed keypads and handles all code management.',
    lockboxes:
      'After-hours vendor access in a Midtown high-rise. Codi manages lockbox placement and building coordination.',
    visitorManagement:
      'Frequent client visits in Midtown. Codi deployed a visitor management system that handles check-in and compliance logging.',
    businessInsurance:
      'Midtown lease COI requirements are strict. Codi manages our business insurance and handles certificate requests on demand.',
    electricalServices:
      'Midtown high-rise required dedicated circuits for trading infrastructure. Codi managed the licensed master electrician and all DOB permit coordination.',
    hvac: 'Multi-floor Midtown office with a complex shared HVAC system. Codi manages our licensed HVAC vendor and coordinates with building engineering for all work.',
    plumbing:
      'Enterprise Midtown office, frequent plumbing needs across two floors. Codi manages licensed vendors, building notification, and scheduling.',
    pestControl:
      'High-density Midtown building. Codi manages quarterly pest control treatments and compliance documentation for our floors.',
    officeMoving:
      'Cross-town Midtown move with 80 people and enterprise IT equipment. Codi managed freight access, mover vetting, and the full setup coordination.',
    mountingInstallation:
      'Seven conference rooms, two boardrooms \u2014 all needed TV and whiteboard mounts. Codi completed the full Midtown floor in one day.'
  },
  officeAssistant: {}
});
